import Mousetrap from 'mousetrap'

export default {
  computed: {
    employmentId() {
      return this.activeEmployment.id
    },

    isAdmin() {
      return this.activeEmployment && this.activeEmployment.is_admin
    },
  },

  mounted() {
    this.bindKeyToNavigatePage('shift+1', 'leave-summary')
    this.bindKeyToNavigatePage('shift+2', 'wall-chart')
    this.bindKeyToNavigatePage('shift+3', 'my-year')
    this.bindKeyToNavigatePage('shift+4', 'reports-allowances')
    this.bindKeyToNavigatePage('alt+n', 'notifications')

    this.bindKeyToOpenModel('alt+i', 'shortcut-modal')

    this.bindKeyToOpenUrl('alt+c', '/companies')
    this.bindKeyToOpenUrl('alt+p', '/my-profile')
    this.bindKeyToOpenUrl('shift+s', '/settings/company')
    this.bindKeyToOpenUrl('shift+d', '/settings/departments')
    this.bindKeyToOpenUrl('shift+a', '/settings/allowances')
    this.bindKeyToOpenUrl('shift+l', '/settings/leave-types')
    this.bindKeyToOpenUrl('shift+h', '/settings/holidays')
    this.bindKeyToOpenUrl('shift+e', '/settings/employees')
    this.bindKeyToOpenUrl('shift+c', '/settings/calendars')
    this.bindKeyToOpenUrl('shift+m', '/settings/limits')
    this.bindKeyToOpenUrl('shift+i', '/settings/import')
    this.bindKeyToOpenUrl('shift+t', '/settings/integrations')
    this.bindKeyToOpenUrl('shift+b', '/settings/billing')

    this.$once('hook:beforeDestroy', () => {
      Mousetrap.unbind(
        'shift+1',
        'shift+2',
        'shift+3',
        'shift+4',
        'alt+h',
        'alt+n',
        'alt+c',
        'alt+p',
        'alt+i',
        'shift+s',
        'shift+d',
        'shift+a',
        'shift+l',
        'shift+e',
        'shift+c',
        'shift+m',
        'shift+i',
        'shift+t',
        'shift+b'
      )
    })
  },

  methods: {
    bindKeyToNavigatePage(key, routeName) {
      this.bindKeyToAction(key, () =>
        this.$router.push({ name: routeName }, () => {})
      )
    },

    bindKeyToOpenUrl(key, path) {
      this.bindKeyToAction(key, () => {
        if (!this.activeCompany) return

        window.location.href = `${path}?company=${this.activeCompany.id}`
      })
    },

    bindKeyToOpenModel(key, modelName) {
      this.bindKeyToAction(key, () => this.$modal.toggle(modelName))
    },

    bindKeyToAction(key, action) {
      Mousetrap.bind(key, e => {
        e.preventDefault()
        action()
      })
    },
  },
}
